import { Id, Member } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import { MemberCard } from 'chat/members/views/card'
import { MembersList } from 'chat/members/views/list'
import { RecipientSearchBar } from 'chat/members/views/search_bar'
import React, { useMemo } from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface Props {
  recipients: readonly Member[] | undefined
  disabledMemberIds?: Id[]
  onMemberPress(member: Member): void
  searchText: string
  setSearchText(term: string): void
  isLoading?: boolean
}

export function RecipientsView({
  disabledMemberIds,
  recipients,
  onMemberPress,
  searchText,
  setSearchText,
  isLoading,
}: Props) {
  const styles = useStyles()

  const disabledMemberIdsSet = useMemo(
    () => new Set(disabledMemberIds),
    [disabledMemberIds]
  )

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <RecipientSearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          isLoading={isLoading}
        />
        <MembersList
          members={recipients}
          renderItem={({ item: member }) => (
            <MemberCard
              member={member}
              disabled={disabledMemberIdsSet.has(member.id)}
              onPress={onMemberPress}
            />
          )}
          extraData={[disabledMemberIds]}
        />
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
  },
}))
